import { render, staticRenderFns } from "./NavisionLicence.vue?vue&type=template&id=95d5c8c4&"
import script from "./NavisionLicence.vue?vue&type=script&lang=js&"
export * from "./NavisionLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports